// src/central/Panel.js
import styled, { css } from "styled-components";

const Panel = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.radii.medium};
  box-shadow: ${({ theme }) => theme.shadows.subtle};
  padding: ${({ padding, theme }) => padding || `${theme.spacing.large} ${theme.spacing.medium}`};
  margin: ${({ margin }) => margin || "0"};
  width: ${({ width }) => width || "auto"};
  max-width: ${({ maxWidth }) => maxWidth || "420px"};
  font-family: ${({ theme }) => theme.typography.fontFamily.body};
  color: ${({ theme }) => theme.colors.text};
  transition: background-color ${({ theme }) => theme.transitions.medium};

  ${({ align }) =>
    align === "center" &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
    `}

  ${({ variant, theme }) =>
    variant === "highlight" &&
    css`
      border: 1px solid ${theme.colors.accent};
      background: ${theme.colors.backgroundAlt};
    `}

  ${({ variant, theme }) =>
    variant === "warning" &&
    css`
      border: 1px solid ${theme.colors.warning};
      background: ${theme.colors.warningBackground || "#fff8f0"};
    `}

  ${({ variant, theme }) =>
    variant === "success" &&
    css`
      border: 1px solid ${theme.colors.success};
      background: ${theme.colors.successBackground || "#f0fff5"};
    `}
`;

export default Panel;